<template>
  <div class="p-6">
    <h1 class="text-2xl font-bold text-neutral-900 mb-6">Настройки навигации</h1>

    <div v-if="loading" class="flex justify-center items-center h-40">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <template v-else>
      <div class="mb-6">
        <button
          @click="openAddGroupModal"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Создать группу
        </button>
      </div>

      <div class="space-y-4">
        <div
          v-for="group in moduleGroups"
          :key="group.id"
          class="bg-white rounded-lg border border-neutral-200 overflow-hidden"
        >
          <div class="flex items-center justify-between p-4">
            <div class="flex items-center gap-3">
              <div class="text-neutral-700">{{ group.name }}</div>
              <span class="text-xs text-neutral-500 bg-neutral-100 px-2 py-0.5 rounded">
                {{ group.module_type?.name || group.moduleType?.name || '' }}
              </span>
            </div>
            <div class="flex items-center gap-2">
              <button
                @click="openEditGroupModal(group)"
                class="px-3 py-1 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded"
              >
                Редактировать
              </button>
              <button
                @click="confirmDelete(group)"
                class="px-3 py-1 text-sm font-medium text-red-600 hover:bg-red-50 rounded"
              >
                Удалить
              </button>
            </div>
          </div>
          <div v-if="group.modules?.length" class="px-4 pb-4">
            <div class="text-sm text-neutral-500 mb-2">Модули в группе:</div>
            <div class="flex flex-wrap gap-2">
              <span
                v-for="m in group.modules"
                :key="m.id"
                class="inline-flex items-center px-2 py-1 bg-neutral-100 rounded text-sm"
              >
                {{ m.name }}
              </span>
            </div>
          </div>
          <div v-else class="px-4 pb-4 text-sm text-neutral-400">
            Модули не привязаны
          </div>
        </div>

        <div v-if="moduleGroups.length === 0" class="text-neutral-500 py-8 text-center">
          Нет созданных групп. Создайте группу и привяжите к ней модули.
        </div>
      </div>

      <AddOrEditGroupModal
        ref="groupModal"
        :modules-for-assignment="modulesForAssignment"
        @saved="getData"
      />

      <div v-if="isConfirmModalVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
          <h2 class="text-lg font-bold mb-4">Подтвердите удаление</h2>
          <p class="text-sm text-gray-700 mb-4">Вы уверены, что хотите удалить группу «{{ groupToDelete?.name }}»?</p>
          <div class="flex justify-end space-x-2">
            <button
              @click="cancelDelete"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Отмена
            </button>
            <button
              @click="proceedDelete"
              class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
            >
              Удалить
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AddOrEditGroupModal from '@/components/navigation/AddOrEditGroupModal.vue'

export default {
  components: { AddOrEditGroupModal },
  data() {
    return {
      loading: true,
      moduleGroups: [],
      modulesForAssignment: [],
      isConfirmModalVisible: false,
      groupToDelete: null,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      Promise.all([
        axios.post('/api/moduleGroup/getModuleGroups'),
        axios.post('/api/moduleGroup/getModulesForGroupAssignment'),
      ])
        .then(([groupsRes, modulesRes]) => {
          this.moduleGroups = groupsRes.data.data || []
          this.modulesForAssignment = modulesRes.data.data || []
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.loading = false
        })
    },
    openAddGroupModal() {
      this.$refs.groupModal?.show()
    },
    openEditGroupModal(group) {
      this.$refs.groupModal?.show(group)
    },
    confirmDelete(group) {
      this.groupToDelete = group
      this.isConfirmModalVisible = true
    },
    cancelDelete() {
      this.isConfirmModalVisible = false
      this.groupToDelete = null
    },
    proceedDelete() {
      if (!this.groupToDelete?.id) return
      axios
        .post('/api/moduleGroup/deleteModuleGroup', { id: this.groupToDelete.id })
        .then(() => {
          this.getData()
          this.cancelDelete()
        })
        .catch((err) => console.error(err))
    },
  },
}
</script>
